'use strict';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.value("fileuploadDefaultOptions", {
  //url             : '/rest/...', // Pas de valeur par défaut, à chaque usage sa ressource.
  dataType: "json",
  autoUpload: true,
  formData: {},
  maxFileSize: 15 * 1024 * 1024,
  // 15Mo
  messages: {}
});
ngModule.factory("$fileUpload", function ($modal) {
  var UploadLoader = function UploadLoader($scope) {
    var self = this,
      loaderScope = null,
      modalPromise = null;
    self.start = function () {
      loaderScope = $scope.$new();
      _.extend({
        progress: 0,
        bitrate: 0
      });
      self.show();
      $scope.$on("fileuploadprogress", self.onProcess);
      $scope.$on('fileuploadstop', self.close);
    };
    self.show = function () {
      modalPromise = $modal.open({
        scope: loaderScope,
        template: require("./fileUploadLoader.html"),
        options: {
          escape: false,
          width: 300,
          dialogClass: "fileupload-loader"
        }
      });
    };
    self.onProcess = function (event, data) {
      loaderScope.progress = data.loaded / data.total * 100;
      loaderScope.bitrate = data.bitrate;
    };
    self.close = function () {
      if (modalPromise) {
        $modal.dismiss(modalPromise);
        modalPromise = null;
        loaderScope.$destroy();
      }
    };
    $scope.$on("$destroy", function () {
      self.close();
    });
  };
  return {
    startLoader: function startLoader($scope) {
      var loader = new UploadLoader($scope);
      loader.start();
    }
  };
});

/**
 * ex :
 * <fileupload-btn btn-label="Upload"  upload-success="onDocumentUpload" options="uploadOptions"></fileupload-btn>
 *
 * attribut icon par défaut : fa-arrow-circle-o-up
 /* attribut btn-class ex: btn-class ="btn-action-small"

 */
ngModule.directive("fileuploadBtn", function (security, urlUtils, $parse, $fileUpload, $dialogBox, $q, $numberFormat, fileuploadDefaultOptions) {
  var openFileSizeTooBigPopin = function openFileSizeTooBigPopin(uploadOptions) {
    $dialogBox.alert({
      title: "Taille du fichier trop importante",
      html: "L'envoi est limité à des fichiers de " + $numberFormat.bytes(uploadOptions.maxFileSize) + " maximum.<br>" + "Essayez de le découper en plusieurs fichiers.<br>" + "Vous pouvez pour les fichiers pdf utiliser des outils en ligne tels que <a href='http://www.ilovepdf.com/fr/diviser_pdf' target='_blank'>celui-ci</a> ou <a href='http://smallpdf.com/fr/diviser-pdf' target='_blank'>celui-là.</a>"
    });
  };
  return {
    restrict: 'EA',
    replace: true,
    template: require("./fileUploadButton.html"),
    scope: {
      options: "<",
      type: "@",
      owner: "@",
      btnLabel: "@",
      btnLabelKey: "@",
      accept: "@",
      beforeUpload: "<",
      uploadSuccess: "@",
      // workaround to provide additionnal info
      hint: "@"
    },
    link: function link($scope, $el, $attrs) {
      $scope.icon = $attrs['icon'] || 'fa-arrow-circle-o-up';
      $scope.btnClass = $attrs['btnClass'];
      $scope.$watch("options", function (options) {
        var mergedOptions = $scope.mergedOptions = _objectSpread({}, fileuploadDefaultOptions, {
          dropZone: $el
        }, options);
        mergedOptions.url = urlUtils.addParams(mergedOptions.url, security.getTokens());
        mergedOptions.formData = _objectSpread({}, mergedOptions.formData, {
          type: $scope.type || "AUTRE_DOCUMENT",
          owner: $scope.owner
        });

        // permet à la fenetre de choix de fichier de choisir plusieurs fichiers.
        if (mergedOptions.multiple === true) {
          $el.find(".file-input").prop('multiple', true);
        }
        mergedOptions.add = function (e, data, other) {
          var addedFile = data.files[0];
          if (addedFile.name === '.DS_Store') {
            console.log('Fichier ignoré ' + addedFile.name);
          } else if (addedFile.size && addedFile.size > mergedOptions.maxFileSize) {
            openFileSizeTooBigPopin(mergedOptions);
          } else {
            var beforeUploadHandler = $scope.beforeUpload;
            if (beforeUploadHandler) {
              $q.when(beforeUploadHandler(mergedOptions, addedFile)).then(function (newFormData) {
                if (newFormData) {
                  $el.find("form[file-upload]").fileupload("option", "formData", newFormData);
                }
                data.submit();
              });
            } else {
              data.submit();
            }
          }
        };
      }, true);
      $scope.$on('fileuploadstart', function (event, file) {
        $fileUpload.startLoader($scope);
      });
      $scope.$on("fileuploadfail", function (event, data) {
        var error = !data.result || data.result.message || data.files[0].error;
        console.log('error fileUpload', data);
        $dialogBox.alert({
          title: "Erreur lors de l'envoi du fichier",
          text: error
        });
      });
      $scope.$on('fileuploaddone', function (event, file) {
        if ($scope.uploadSuccess) {
          var handler = $parse($scope.uploadSuccess)($scope.$parent);
          handler(file.result, file);
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/file-upload/fileUpload.js
// module id = 2937
// module chunks = 13